import { Caption1, makeStyles } from '@fluentui/react-components';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { tokens } from '@vigeo/ui';
import { ReviewQueue, queueContext } from '@/features/review';
import { fetchReviewQueue, now } from '@/lib/api';
import { fetchAuthState } from '@/lib/auth';

const useStyles = makeStyles({
  page: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXL },
  head: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXXS, minWidth: 0 },
  /** Page-name voice (24/700), as on People and the Person Overview. */
  title: { margin: 0, fontSize: tokens.fontSizeBase600, lineHeight: tokens.lineHeightBase600, fontWeight: tokens.fontWeightBold },
});

const PURPOSE = 'Submissions that need an HR decision before they count.';

/**
 * The Review page (checkpoint 7C): title, the real count of what is waiting, and the queue.
 * The count reads the same query the queue and the shell badge read, so it costs no request.
 */
export function ReviewQueuePage() {
  const styles = useStyles();
  const [params] = useSearchParams();
  const auth = useQuery({ queryKey: ['auth'], queryFn: fetchAuthState, retry: false });
  const queue = useQuery({ queryKey: ['review'], queryFn: () => fetchReviewQueue() });
  // The existing gate, unchanged: only signed-in admins decide.
  const canDecide = auth.data?.status === 'signed-in' && auth.data.user.isAdmin;
  const context = queue.data === undefined ? PURPOSE : `${queueContext(queue.data.items, now(), queue.data.cursor !== null)} · ${PURPOSE}`;

  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <h1 className={styles.title}>Review</h1>
        <Caption1>{context}</Caption1>
      </header>
      <ReviewQueue canDecide={canDecide} initialSelectedId={params.get('instance')} />
    </div>
  );
}
